export enum GameType {
    DOLL,
    DRESS,
    HIEROGLYPH,
    MASK,
    QUILT,
    PINATA,
    PUPPET,
    NUM_ELEMENTS,
}

export const GAME_ITEM_COUNT: number[] = [
    2, // DOLL
    2, // DRESS
    1, // HIEROGLYPH
    6, // MASK
    2, // QUILT
    1, // PINATA
    1, // PUPPET
];
